import { render, staticRenderFns } from "./EditMenu.vue?vue&type=template&id=c7f19a12&scoped=true"
import script from "./EditMenu.vue?vue&type=script&lang=js"
export * from "./EditMenu.vue?vue&type=script&lang=js"
import style0 from "./EditMenu.vue?vue&type=style&index=0&id=c7f19a12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f19a12",
  null
  
)

export default component.exports